﻿import { Inject, Pipe, Injectable } from "@fiqas/angular-utils"
import { FIQAssist } from "../app";
import { TranslationService } from "../services/TranslationService";
import { LocalizationData } from "../models/localization";

export class LinefeedToBreakFilter {

    @Pipe({
        module: FIQAssist,
        selector: 'linefeedtobreak',
        pure: true
    })
    public static LinefeedToBreakFilter() {
        return (text: string): string => text ? text.replace(/(?:\r\n|\r|\n)/g, '<br/>') : "";
    }
}
